.errorContainer {
  margin-top: $spacingSM;
  padding-left: $spacingSM;
  padding-right: $spacingSM;
  text-align: left;
}

.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
}
